import api from '../api/axios';

export const authService = {
  registro: async (datos) => {
    const { data } = await api.post('/auth/register', datos);
    return data;
  },

  login: async (datos) => {
    const { data } = await api.post('/auth/login', datos);
    return data;
  },

  me: async () => {
    const { data } = await api.get('/auth/profile');
    return data;
  },

  recuperarContrasena: async (email) => {
    const { data } = await api.post('/auth/recuperar-contrasena', { email });
    return data;
  },

  restablecerContrasena: async ({ email, codigo, nueva_password }) => {
    const { data } = await api.post('/auth/restablecer-contrasena', { email, codigo, nueva_password });
    return data;
  },

  actualizarPerfil: async (datos) => {
    const { data } = await api.put('/auth/me', datos);
    return data;
  },
};
